"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countryReducer = void 0;
const country_1 = require("../actions/country");
const countryReducer = (country = '', action) => {
    return action.type === country_1.SET_COUNTRY ? action.payload : country;
};
exports.countryReducer = countryReducer;
//# sourceMappingURL=country.reducer.js.map